

































import deck from '@/store/modules/deck';
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({components: {}})
export default class Preferences extends Vue {
    isActive(background: string) {
        return this.background === background;
    }

    setBackground(background: string) {
        deck.setBackground(background);
    }

    updateName(name: string) {
      deck.setName(name);
    }

    get background() {
        return deck.Background;
    }

    get name() {
        return deck.Name;
    }

    get isTemplate() {
        return deck.Type === 'deck-template';
    }

    thisVersion() {
        if (process.env.VUE_APP_BRAND === 'GT') {
            return 'gt';
        }
        return 'demo';
    }

}
